import { UserOutlined } from "@ant-design/icons"
import { Card, Space, Typography } from "antd"
import React, { type ReactNode } from "react"

import { cn } from "../../../../utils/cn.ts"

interface SettingsCardProps {
  iconWrapperClassName?: string
  icon: ReactNode
  children: ReactNode
  title: string
  subtitle?: ReactNode
}

export function SettingsCard({
  iconWrapperClassName,
  icon,
  title,
  subtitle,
  children
}: SettingsCardProps) {
  return (
    <Card
      className={"break-inside-avoid"}
      classNames={{ body: "p-3", header: "p-3" }}
      title={
        <Space align="start">
          <div
            className={cn(
              "py-1 px-2 rounded-md aspect-square",
              iconWrapperClassName
            )}
          >
            {icon}
          </div>
          <div className="flex flex-col">
            <Typography.Title className={"mb-0 font-semibold"} level={4}>
              {title}
            </Typography.Title>
            {subtitle ? (
              <Typography.Text type="secondary" className="font-normal">
                {subtitle}
              </Typography.Text>
            ) : null}
          </div>
        </Space>
      }
    >
      {children}
    </Card>
  )
}
